import NewAccount from '@/views/account/NewAccountView.vue';
import NewAccountComplete from '@/views/account/NewAccountComplete.vue';
import NewAccountConfirmEmail from '@/views/account/NewAccountConfirmEmail.vue';
import ResetPassword from '@/views/account/ResetPassword.vue';
import ForgotPassword from '@/views/account/ForgotPassword.vue';
export const signUpRoutes = [
  {
    path: '/create-account',
    name: 'NewAccount',
    component: NewAccount,
    meta: { guest: true },
  },
  {
    path: '/create-account-complete',
    name: 'NewAccountComplete',
    component: NewAccountComplete,
    meta: { guest: true },
  },
  {
    path: '/confirm-email',
    name: 'NewAccountConfirmEmail',
    component: NewAccountConfirmEmail,
    meta: { guest: true },
  },
  {
    path: '/reset-password',
    name: 'ForceReset',
    component: ResetPassword,
    meta: { requiresAuth: true },
  },

  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: { guest: true },
  },
];
